import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export interface ActivePayrollCalendar {
  calendarId: string;
  calendarName?: string;
  alreadyUsed?: boolean;
}

const useGetActivePayrollCalendarsQuery = () => {
  const { data, isLoading, isSuccess } = useQuery(
    [API_URL.PAYROLL_CALENDARS_ORGANIZATIONS_ORGANIZATION_PATH_REDUCED],
    () => api.get(API_URL.PAYROLL_CALENDARS_ORGANIZATIONS_ORGANIZATION_PATH_REDUCED)
  );

  const formattedData = useMemo<ActivePayrollCalendar[] | undefined>(
    () =>
      data?.data?.map(
        (item): ActivePayrollCalendar => ({
          calendarId: toString(item?.calendar_id),
          calendarName: item?.calendar_name,
          alreadyUsed: item?.already_used,
        })
      ),
    [data?.data]
  );

  return {
    formattedData,
    isLoading,
    isSuccess,
  };
};

export default useGetActivePayrollCalendarsQuery;
